export const environment = {
    version: '1.5.22',
    production: true,
    portalClient: true,
    baseHref: '/ALTA/',
    services: {
        paths: {
            accept_order_signatures: '/onboarding/accept_ordersignatures',
            accept_test_sign_signatures: '/clientwebsite/onboardingclient/accept_profiletestsignatures',
            add_selected_products: '/clientwebsite/onboardingclient/add_selectedproducts',
            add_order_selected_product: '/clientwebsite/onboardingclient/add_orderselectedproduct',
            modify_order_selected_product: '/clientwebsite/onboardingclient/modify_orderselectedproduct',
            delete_order_selected_product: '/clientwebsite/onboardingclient/delete_orderselectedproduct',
            check_client: '/onboardingcaptcha/check_idemailtel',
            check_email: '/clientwebsite/onboardingclient/check_email',
            check_phone: '/clientwebsite/onboardingclient/check_phone',
            check_selected_products: '/clientwebsite/onboardingclient/check_productsappropriateness',
            continue_order_electronic_signature: '/clientwebsite/onboardingclient/continue_orderelectronicsignature',
            continue_test_electronic_signature: '/clientwebsite/onboardingclient/continue_profiletestelectronicsignature',
            evaluate_fee: '/onboarding/evaluate_portfoliofee',
            finalize_contract: '/clientwebsite/onboardingclient/finalize_onboard',
            cancel_contract: '/clientwebsite/onboardingclient/cancel_onboarding',
            get_advisory_models: '/clientwebsite/onboardingclient/get_servicestypes',
            get_client: '/onboarding/get_clientbydocumentid',
            get_client_profile: '/clientwebsite/clientclient/get_clientdata',
            get_contract: '/clientwebsite/onboardingclient/get_contract',
            get_contracts: '/clientwebsite/client/get_clientportfolios',
            get_contract_action_signatories: '/clientwebsite/onboardingclient/get_gdcactionsignatories',
            get_contract_data: '/portfolio/get_portfoliodata',
            get_contract_signatories: '/clientwebsite/onboardingclient/get_onboardingsignatories',
            get_contract_signed_documents: '/onboarding/get_signeddocuments',
            get_documents: '/clientwebsite/documentclient/get_legaldocuments',
            get_document: '/clientwebsite/onboardingclient/get_document',
            get_full_client: '/clientwebsite/onboardingclient/get_fullclientdata',
            get_legal_conditions_disclaimer: '/onboardingpublic/get_legalconditionsdisclaimer',
            get_model: '/modelportfolio/get_modelportfolio',
            get_model_pdf: '/modelportfolio/get_modelportfolioPdfBase64',
            get_optimal_selected_product: '/clientwebsite/onboardingclient/get_optimalclassselectedproduct',
            get_order_documents: '/onboarding/get_ordersdocuments',
            get_product: '/onboardingpublic/get_product',
            get_product_document: '/clientwebsite/onboardingclient/get_costandtaxesdocument',
            get_products: '/onboardingpublic/get_products',
            get_profile: '/clientwebsite/clientclient/get_clientdata',
            get_selected_products: '/clientwebsite/onboardingclient/get_selectedproducts',
            get_selected_products_signatories: '/clientwebsite/onboardingclient/get_selectedproductsignatories',
            get_test: '/clientwebsite/testclient/get_convenienceprofilequestionnaire',
            get_test_results: '/clientwebsite/testclient/get_investorprofiletestdata',
            get_test_suitability: '/clientwebsite/testclient/get_suitabilityprofilequestionnaire',
            get_test_sign_documents: '/clientwebsite/onboardingclient/get_profiletestdocuments',
            get_type_of_orders: '/clientwebsite/onboardingclient/get_typeoforders',
            get_valid_model: '/proposal/get_validmodelportfolios',
            get_validate_client_notifications: '/clientwebsite/portfolioclient/get_clientvalidatenotifications',
            reject_client: '/onboarding/reject_client',
            reject_contract: '/onboarding/reject_contract',
            remember_order_electronic_signature: '/clientwebsite/onboardingclient/send_orderelectronicsignaturereminder',
            remove_document: '/clientwebsite/onboardingclient/remove_document',
            remove_selected_product: '/clientwebsite/onboardingclient/remove_selectedproduct',
            set_contract: '/clientwebsite/onboardingclient/set_contract',
            set_contract_copy_documents: '/clientwebsite/onboardingclient/set_documentsportfoliofromportfolio',
            set_contract_with_products: '/onboardingcaptcha/set_onboarding',
            set_full_client: '/clientwebsite/onboardingclient/set_fullclientdata',
            set_fee: '/onboarding/set_portfoliofee',
            set_selected_products: '/clientwebsite/onboardingclient/set_contractappropriateness',
            set_test: '/clientwebsite/testclient/evaluate_profilequestionnaire',
            set_transfer: '/clientwebsite/onboardingclient/set_portfolioinitialtransfers',
            sign_disinvestment: '/onboarding/add_portfoliogdcwithdrawal',
            sign_model: '/onboarding/set_portfoliogdcmodelportfolio',
            sign_test: '/clientwebsite/onboardingclient/start_profilesignature',
            sign_transfer: '/onboarding/add_portfoliogdccontribution',
            unfinalize_client: '/onboarding/unfinalize_client',
            unfinalize_contract: '/onboarding/unfinalize_contract',
            upload_document: '/clientwebsite/documentclient/upload_document',
            upload_signed_order_document: '/onboarding/upload_signedorderdocument',
            upload_test_sign_document: '/clientwebsite/onboardingclient/upload_profiletestdocument',
            validate_client: '/onboarding/validate_client',
            validate_client_data: '/onboarding/validate_clientdata',
            validate_contract: '/onboarding/validate_contract',
            validate_document: '/onboarding/validate_document',
            validate_notification: '/onboarding/send_validationnotification',

            get_productsbyordertype: '/onboarding/get_productsbyordertype',
            get_productsbyordertypeclient: '/onboardingclient/get_productsbyordertype',
        },
    },
};
